import React from "react";

import { Controller } from "react-hook-form";

import TextField from "@mui/material/TextField";

const TextFieldController = ({
  control,
  name,
  rules,
  placeholder,
  type,
  ...props
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field }) => (
      <TextField
        {...field}
        {...props}
        fullWidth
        placeholder={placeholder}
        type={type}
        slotProps={{
          inputLabel: {
            shrink: true,
          },
        }}
      />
    )}
  />
);

export default TextFieldController;
